import { createSelector } from '@reduxjs/toolkit';

const selectWorkCalendar = (state) => state.workCalendar;

export const selectWorkCalendarEmployers = createSelector(
  [selectWorkCalendar],
  (state) => state.employers.entities
);

export const selectWorkCalendarProjectsEntities = createSelector(
  [selectWorkCalendar],
  (state) => state.projects.entities
);

export const selectWorkCalendarResources = createSelector(
  [selectWorkCalendar],
  (state) => state.resources.entities
);
export const selectWorkCalendarResourcesArray = createSelector(
  [selectWorkCalendarResources],
  (resources) => {
    return Object.values(resources);
  }
);

export const selectWorkCalendarProjectItemsArray = createSelector(
  [selectWorkCalendarProjectsEntities],
  (projects) => Object.values(projects)
);

export const selectWorkCalendarEmployersArray = createSelector(
  [selectWorkCalendarEmployers],
  (employers) => Object.values(employers)
);

export const selectIsPersonalWorkCalendarMode = createSelector(
  [selectWorkCalendar],
  (state) => state.isPersonalWorkCalendarMode
);

export const selectRecordDialogData = createSelector(
  [selectWorkCalendar],
  (workCalendarState) => workCalendarState.records_demo.recordDialogInitialData
);

export const selectWorkCalendarLoading = createSelector(
  [selectWorkCalendar],
  (workCalendarState) => workCalendarState.loading
);

export const selectIsProjectDataLoading = createSelector(
  [selectWorkCalendar],
  (state) => {
    return state.projectsDataLoading;
  }
);

export const selectIsConfirmApprovalDialogOpen = createSelector(
  [selectWorkCalendar],
  (state) => state.isConfirmApprovalDialogOpen
);
